import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Brand } from "@/components/site/brand";
import { DisclaimerBar } from "@/components/site/disclaimer-bar";

export const Route = createFileRoute("/reset-password")({
  head: () => ({ meta: [{ title: "Set new password — CryptoBull Pro" }] }),
  component: Reset,
});

function Reset() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  return (
    <div className="min-h-screen">
      <DisclaimerBar />
      <div className="px-4 py-10 flex flex-col items-center">
        <Brand size="lg" />
        <div className="mt-8 w-full max-w-md glass rounded-3xl p-7">
          <h1 className="text-2xl font-semibold">Choose a new password</h1>
          <form className="mt-5 space-y-4" onSubmit={async (e) => {
            e.preventDefault();
            const pw = String(new FormData(e.currentTarget).get("password"));
            setLoading(true);
            const { error } = await supabase.auth.updateUser({ password: pw });
            setLoading(false);
            if (error) { toast.error(error.message); return; }
            toast.success("Password updated");
            navigate({ to: "/dashboard" });
          }}>
            <div className="space-y-2"><Label>New password</Label><Input name="password" type="password" minLength={8} required /></div>
            <Button type="submit" className="w-full" disabled={loading}>{loading ? "Updating…" : "Update password"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}